@import 'apps/webcomponents/src/assets/common.scss';

.wrapper {
  flex-direction: column;
  height: 100%;
  overflow-y: hidden;
}

.content {
  flex-grow: 2;
  height: 50vh;

  .grid {
    height: 100%;
    margin-top: -33px;
    margin-left: -20px;
  }

  .grid-view {
    min-height: 100%;
    align-items: stretch;
  }
}
